import { Link, useNavigate } from "react-router-dom";

import blogImg1 from "../../assets/images/blog/1.jpg";

const SinglePost = (props) => {
  const navigate = useNavigate(); // Get the navigate function
  const options = { year: 'numeric', month: 'short' };
  const {blog,blogClass} = props;
  const handlePostClick = (post) => {
    navigate(`/blog/${post._id}`, { state: { post } }); // Navigate to the post detail page with state
  };
  return (
    <div className={blogClass ? blogClass : "blog__card mb-50"} style={{marginBottom:20}} onClick={() => handlePostClick(blog)} >
      <div   className="blog__thumb w-img p-relative">
      <Link to="#" className="blog__thumb--image">
          <img 
            crossOrigin="anonymous" 
            src={blog.coverMobile ? `https://back.yourfrenchteachers.com/${blog.coverMobile}` : blogImg1}
            alt={blog.displayTitle} 
          />
        </Link>
        <em className="b_date">
        {blog.createdAt
            ? new Date(blog.createdAt).toLocaleDateString('en-US', options).replace(',', '')
            : "April 18" // Default date
          }
        </em>
      </div>
      <div className="blog__card--content">
        <div className="blog__card--content-area mb-25">
          {/* <span className="blog__card--date">
            {blogCategory ? blogCategory : "Education"}
          </span> */}
          <h3 className="blog__card--title">
            <Link to="#">
              {" "}
              {blog.displayTitle}
            </Link>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default SinglePost;
